import { Component } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { User } from '../../model/user';
import { Friendship, FriendshipStatus } from '../../model/friends';
import { ActivatedRoute } from '@angular/router';
import { PlayerSearch } from '../../model/player-search';
import { CourtReservation } from '../../model/court-reservation';
import { RouterService } from '../../services/router.service';
import { FriendsService } from '../../services/friends.service';

@Component({
  selector: 'app-search-players',
  standalone: true,
  imports: [],
  templateUrl: './search-players.component.html',
  styleUrl: './search-players.component.css'
})
export class SearchPlayersComponent {

  constructor(private localStorageService: LocalStorageService, private route: ActivatedRoute,
              private routerService: RouterService, private friendsService: FriendsService) {}

  friendshipsPage: boolean = false;
  players: User[] = [];
  private allUsers: User[] = [];
  currentUser!: User;
  private currentUserId = 0;
  friendships: Friendship[] = [];
  idx: number = 0;
  playerSearch!: PlayerSearch;
  courtReservation!: CourtReservation;

  ngOnInit(): void {
    this.currentUser =
      (this.safeGetItem<User>('currentUser') as User) ||
      ({ id: 0, username: '', name: '', last_name: '' } as unknown as User);
    this.currentUserId = this.normalizeId(this.currentUser?.id);
    this.currentUser = { ...this.currentUser, id: this.currentUserId } as User;
    this.playerSearch =
      (this.safeGetItem<PlayerSearch>('playerSearch') as PlayerSearch) ||
      new PlayerSearch(0, this.currentUser.gender);
    this.courtReservation =
      (this.safeGetItem<CourtReservation>('courtReservation') as CourtReservation) ||
      ({ player_ids: [-1, -1, -1, -1] } as CourtReservation);
    this.allUsers = (this.safeGetItem<User[]>('users') as User[]) || [];

    this.route.paramMap.subscribe(params => {
      this.idx = Number(params.get('idx') as string);
    });

    this.loadFriendships();
    this.applyFilters();
  }

  private safeGetItem<T>(key: string): T | null {
    try {
      return this.localStorageService.getItem(key) as T;
    } catch (error) {
      return null;
    }
  }

  private loadFriendships(): void {
    if (!this.currentUserId) {
      this.applyFilters();
      return;
    }

    this.friendsService.getFriendshipsForUser(this.currentUserId).subscribe({
      next: (friendships: Friendship[]) => {
        this.friendships = friendships || [];
        this.applyFilters();
      },
      error: (error) => {
        console.error('Failed to load friendships', error);
        this.friendships = [];
        this.applyFilters();
      },
    });
  }

  private applyFilters(): void {
    let filtered = [...this.allUsers];

    if (this.currentUserId) {
      filtered = filtered.filter((user) => user.id !== this.currentUserId);
    }

    filtered = filtered.filter((user) => !this.isFriend(user.id));

    if (this.playerSearch?.league > 1) {
      this.players = [];
      return;
    }

    if (this.playerSearch) {
      filtered = filtered.filter((user) => user.gender == this.playerSearch.gender);
    }

    this.players = filtered;
  }

  private isFriend(userId: number): boolean {
    return this.friendships.some((friendship) => {
      if (
        (friendship.user_id === this.currentUserId && friendship.friend_id === userId) ||
        (friendship.friend_id === this.currentUserId && friendship.user_id === userId)
      ) {
        return friendship.status === FriendshipStatus.Approved;
      }
      return false;
    });
  }

  invited(i: number): boolean {
    for (let j = 0; j < this.courtReservation.player_ids.length; j++) {
      if (this.courtReservation.player_ids[j] == i) {
        return true;
      }
    }
    return false;
  }

  invite(i: number) {
    for (let j = 0; j < this.courtReservation.player_ids.length; j++) {
      if (this.courtReservation.player_ids[j] == i) {
        this.courtReservation.player_ids[j] = -1;
        if (j < this.idx || this.idx == -1) {
          this.idx = j;
        }
        this.localStorageService.setItem('courtReservation', this.courtReservation);
        return;
      }
    }

    if (this.idx < this.courtReservation.player_ids.length) {
      this.courtReservation.player_ids[this.idx] = i;
      this.localStorageService.setItem('courtReservation', this.courtReservation);
      if (this.idx + 1 < this.courtReservation.player_ids.length &&
            this.courtReservation.player_ids[this.idx + 1] == -1) {
              this.idx = this.idx + 1;
      } else {
        this.idx = -1;
      }
    }
  }

  availablePlayer(i: number) {
    this.routerService.navigateTo('available-players/' + i + "/" + this.idx);
  }

  private normalizeId(value: unknown): number {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }

    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    return 0;
  }
}
